import React from 'react';
import { useViewlogies } from 'context';
import { FormattedMessage } from 'react-intl';
import VideoInterface from '../VideoInterface';
import './planningResource.scss';
import planningAheadImg from 'assets/preplan.jpg';

const PlanningResource = () => {
    const {
        event: { preplanningUrl, preplanningVideoUrl, firstName, lastName, color, isLoggedIn },
    } = useViewlogies();

    // if (!isLoggedIn) {
    //     return null;
    // }

    const videoUrl = preplanningVideoUrl || 'https://vimeo.com/1109821725';

    const planningAhead = (
        <VideoInterface
            videoUrl={videoUrl}
            color={color}
            title={
                <FormattedMessage
                    id="features.Viewlogy.Resources.planningAhead"
                    defaultMessage="Give The Ultimate Gift"
                />
            }
            description={
                <FormattedMessage
                    id="features.Viewlogy.Resources.planningAheadDescription"
                    defaultMessage="By planning for the inevitable, you insure peace of mind for your loved ones, avoid emotional spending, and protect against inflation."
                />
            }
            link={preplanningUrl}
            linkText={
                <FormattedMessage
                    id="features.Viewlogy.Resources.planningAheadLink"
                    defaultMessage="Learn about the benefits"
                />
            }
        />
    );

    return (
        <>
            <div className="planning-resource">{planningAhead}</div>
        </>
    );
};

export default PlanningResource;
